import { useEffect, useState } from 'react';

export const useAuthentications = (duration: number) => {
    const [auths, setAuths] = useState(0);

    useEffect(() => {
        // mock will be replaced when stars logic is decided
        const calc = () => setAuths(Math.round(((Math.random() * duration) / 1000) * 2));

        calc();

        const timer = setInterval(() => {
            calc();
        }, duration);

        return () => clearInterval(timer);
    }, []);

    return { duration, auths };
};
